import { t } from "@/i18n";
import type { SelectOption } from "@/interface/ShareWindow/PermissionSelect/PermissionSelect";
import {
    AccessDeleteEnum,
    AccessEnum,
    type AccessOption,
    BoardAccessEnum,
    getAccessDeleteEnumToText,
    getBoardAccessEnumToText,
} from "@/interface/ShareWindow/types";

export const getOptions = (): SelectOption<AccessOption>[] => {
    const accessDeleteEnumToText = getAccessDeleteEnumToText();
    const boardAccessEnumToText = getBoardAccessEnumToText();

    return [
        {
            value: AccessDeleteEnum.edit,
            label: accessDeleteEnumToText[AccessDeleteEnum.edit],
        },
        {
            value: AccessDeleteEnum.view,
            label: accessDeleteEnumToText[AccessDeleteEnum.view],
        },
        {
            value: BoardAccessEnum.viewCopy,
            label: boardAccessEnumToText[BoardAccessEnum.viewCopy],
        },
        {
            value: AccessDeleteEnum.delete,
            label: accessDeleteEnumToText[AccessDeleteEnum.delete],
        },
    ];
};

export const getProjectSelectOptions = () => [
    {
        value: AccessEnum.edit,
        label: t("share.accessEdit"),
    },
    {
        value: AccessEnum.view,
        label: t("share.accessView"),
    },
    {
        value: AccessEnum.viewCopy,
        label: t("share.accessViewCopy"),
    },
];

export const PASSWORD_REG = /^(?=.*[a-zA-Z])[a-zA-Z0-9!@#$%^&*()]{4,50}$/;
